<template>
  <div class="v-upoladFail">
    <div class="iconBox">
      <img src="@/assets/images/failed.png" alt="" class="failed" />
      <div class="text">上传失败：未查询到发票</div>
    </div>
    <div class="tips">
      <div class="tips-text">可能是如下原因造成：</div>
      <div class="tips-text">1、发票数据暂未上传税务机关系统</div>
      <div class="tips-text">2、发票查询信息录入有误</div>
      <div class="tips-text">3、发票真实性需要确认</div>
    </div>
    <div class="buttonGroup">
      <van-button class="goBack" @click="goBack">返回</van-button>
      <van-button type="danger" class="continueUpload" @click="onContinueUpload"
        >继续上传</van-button
      >
    </div>
  </div>
</template>
<script>
import { continueUpload } from '@/utils/invoiceCheck';

export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    goBack() {
      window.location.href = '/supermarket/v2/uploadTicket';
    },
    onContinueUpload() {
      console.log(this.$route.query.type, '==continueUpload');
      continueUpload(this.$route.query.type);
    },
  },
};
</script>
<style lang="scss" scoped>
.v-upoladFail {
  background: #fff;
  height: 100%;
  .iconBox {
    height: 235px;
    .failed {
      height: 60px;
      width: 60px;
      margin-top: 91px;
      margin-bottom: 20px;
    }
    .text {
      font-family: PingFangSC-Medium;
      font-size: 17px;
      color: #1c2438;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
    }
  }
  .tips {
    height: 90px;
    background: #f5f5f5;
    padding: 12px 16px;
    box-sizing: border-box;
    .tips-text {
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #7c7c7c;
      letter-spacing: 0;
      font-weight: 400;
      text-align: left;
    }
  }
  .buttonGroup {
    margin: 16px;
    display: flex;
    .goBack {
      flex: 1;
      margin-right: 15px;
      border-radius: 4px;
    }
    .continueUpload {
      flex: 1;
      border-radius: 4px;
      background: #ff6538;
    }
    .goBack >>> .van-button__text {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #2f3133;
      text-align: center;
      font-weight: 400;
      line-height: 24px;
    }
    .continueUpload >>> .van-button__text {
      font-family: PingFangSC-Regular;
      font-size: 16px;
      text-align: center;
      font-weight: 600;
      line-height: 24px;
    }
  }
}
</style>
